import { useQuery, useMutation } from "@tanstack/react-query";
import { QueryModule } from "@/data/queryModules";
import { MutationEffectsOptions, useMutationEffects } from "@/data/useMutationEffects";
import { AppQueryOptions, AppMutationOptions } from "@povio/openapi-codegen-cli";
import { WatchlistModels } from "./watchlist.models";
import { WatchlistApi } from "./watchlist.api";

export namespace WatchlistQueries {

export const moduleName = QueryModule.Watchlist;

export const keys = {
    all: [moduleName] as const,
    getJobFits: () => [...keys.all, "/watchlist/jobs/job-fits", ] as const,
};


 /** 
 * Query `useGetJobFits`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<WatchlistModels.WatchlistJobFitListResponseDto> } 
 * @statusCodes [200, 401]
 */
export const useGetJobFits = <TData>(options?: AppQueryOptions<typeof WatchlistApi.getJobFits, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getJobFits(),
    queryFn: WatchlistApi.getJobFits
    ,
    ...options,
  });
};








 /** 
 * Mutation `useCalculateJobFit`
 * @param { WatchlistModels.CalculateJobFitDto } mutation.data Body parameter
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<WatchlistModels.WatchlistJobFitFindByTitleResponseDto> } 
 * @statusCodes [201, 401]
 */
export const useCalculateJobFit = (options?: AppMutationOptions<typeof WatchlistApi.calculateJobFit, { data: WatchlistModels.CalculateJobFitDto,  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: ( { data } ) => 
      
            WatchlistApi.calculateJobFit(data)
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      await runMutationEffects(resData, options);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};







 /** 
 * Mutation `useFindJobFitByTitle`
 * @param { WatchlistModels.FindJobFitByTitleDto } mutation.data Body parameter
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<WatchlistModels.WatchlistJobFitFindByTitleResponseDto> } 
 * @statusCodes [200, 401]
 */
export const useFindJobFitByTitle = (options?: AppMutationOptions<typeof WatchlistApi.findJobFitByTitle, { data: WatchlistModels.FindJobFitByTitleDto,  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: ( { data } ) => 
      
            WatchlistApi.findJobFitByTitle(data)
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      await runMutationEffects(resData, options);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};





}
